/**
 * useAccountManagementTab Hook
 * 출금제한 페이지 탭 관리 훅
 */
import { useState, useEffect, useCallback } from 'react';
import { getItem } from '@/shared/utils/storage';

export type AccountTab = 'partner' | 'rider';

export const useAccountManagementTab = (
  onPartnerTabChange?: () => void
) => {
  const [activeTab, setActiveTab] = useState<AccountTab>('partner');
  const [userType, setUserType] = useState<string>('');

  // 사용자 타입 확인
  useEffect(() => {
    const userTypeValue = getItem<string>('USER_TYPE');
    setUserType(userTypeValue || '');
  }, []);

  // 탭 변경 핸들러
  const handleTabChange = useCallback((tab: AccountTab) => {
    setActiveTab(tab);
    if (tab === 'partner' && onPartnerTabChange) {
      // 협력사 탭 클릭 시 콜백 실행
      onPartnerTabChange();
    }
  }, [onPartnerTabChange]);

  return {
    activeTab,
    userType,
    handleTabChange
  };
};

